import { useEffect, useState } from 'react';
import { useFlatsDataContext } from '../../../../../../contexts/FlatsDataContext';
import { paths } from '../../../../../../settings';


import styles from './ContactForm.module.css';

const ContactForm: React.FC<{}> = (): JSX.Element => {
    const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
    const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });
    const { contextSelectedFlat } = useFlatsDataContext();

    useEffect(() => {
        setIsSubmitted(false);
        setFormData({ name: '', email: '', phone: '', message: '' });
    }, [contextSelectedFlat]);

    useEffect(() => {
        /*
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.addedNodes.length > 0) {
                    const successMessage = document.querySelector('#fluentform_3_success');
                    if (successMessage && !isSubmitted) {
                        setIsSubmitted(true);
                        observer.disconnect();
                    }
                }
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });

        return () => observer.disconnect();
        */

    }, [isSubmitted, contextSelectedFlat]);

    /**
     * Handles input changes for form fields by updating the form data state.
     * @param {React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>} e - The input change event.
     * @returns {void}
    */
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    /**
     * Handles reference Fluents Form submission.
     * Maps the input values to the Fluents Form inputs.
     * @param {React.FormEvent} e - The form submit event.
     * @returns {void}
    */
    const handleSubmit = (e: React.FormEvent): void => {
        e.preventDefault();

        const fluentFlatName = document.getElementById('ff_3_input_text_2') as HTMLInputElement;
        const fluentFormName = document.getElementById('ff_3_input_text') as HTMLInputElement;
        const fluentFormEmail = document.getElementById('ff_3_email') as HTMLInputElement;
        const fluentFormPhone = document.getElementById('ff_3_input_text_1') as HTMLInputElement;
        const fluentFormMessage = document.getElementById('ff_3_description') as HTMLTextAreaElement;

        if (fluentFlatName) {
            fluentFlatName.value = contextSelectedFlat.name;
        }
        if (fluentFormName) {
            fluentFormName.value = formData.name;
        }
        if (fluentFormEmail) {
            fluentFormEmail.value = formData.email;
        }
        if (fluentFormPhone) {
            fluentFormPhone.value = formData.phone;
        }
        if (fluentFormMessage) {
            fluentFormMessage.value = formData.message;
        }

        const fluentForm = document.querySelector('.ff-btn-submit') as HTMLFormElement;
        if (fluentForm) {
            fluentForm.click();

            setTimeout(() => {
                setIsSubmitted(true);
            }, 500);
        }
    };

    return (
        <div className={styles.wrapper}>
            <h3>Zapytaj o ofertę</h3>

            { !isSubmitted ? <form onSubmit={handleSubmit}>
                <input
                    type="text"
                    name="name"
                    placeholder="Imię i nazwisko"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                />
                <input
                    type="email"
                    name="email"
                    placeholder="E-mail"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                />
                <input
                    type="tel"
                    name="phone"
                    placeholder="Numer telefonu"
                    value={formData.phone}
                    onChange={handleInputChange}
                />
                <textarea
                    name="message"
                    rows={4}
                    placeholder="Treść wiadomości"
                    value={formData.message}
                    onChange={handleInputChange}
                ></textarea>
                <div className={styles.policyWrapper}>
                    <input
                        type="checkbox"
                        id="privacyPolicy"
                        required
                    />
                    <label htmlFor="privacyPolicy">
                        Wyrażam zgodę na <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">politykę prywatności</a>.
                    </label>
                </div>
                <button className={styles.submitButton} type="submit">Wyślij</button>
            </form>
            :
            <p>Dziękujemy za wiadomość. Skontaktujemy się wkrótce.</p>
            }
            <div className={styles.contactWrapper}>
                <h4>Skontaktuj się</h4>
                <div className={styles.contactIcons}>
                    <a href="tel:+48728764854">
                        <img className={styles.contactIcon} src={`${paths.assets}/icons/phone.png${paths.version}`} alt="Phone" width={34} height={34} />
                    </a>
                    <a href="tel:+48728764854" className={styles.contactPhone}>
                       +48 728 764 854
                    </a>
                </div>
            </div>
        </div>
    );
};

export default ContactForm;